<template>
    <div class="content__sidebar">
        <div class="menu-toggle" :class="{'open': isLoading}" @click="toggleClass">
            <span class="menu-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu "><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
            </span>
            <span class="menu-close">
                <img src="close.svg" alt="">
            </span>
        </div>
        <nav class="navbar">
            <div class="navbar-logo">
                <router-link to="/" class="navbar__logo">
                  <svg viewBox="0 0 31 31"><g fill="#FFFFFF" fill-rule="nonzero"><path d="M0 3h8.696L20 14.55 9.064 29h-7.96l10.81-14.256zM22.162 13L32 3h-8.668L18 8.619zM18 22.323L23.004 29H31l-9.01-12z"></path></g></svg>
                  <span class="logo-text">Media Mentions</span>
                </router-link>                
            </div>
            <div class="navbar__menu">
                <ul class="navbar__menu__links">
                    <li>
                        <router-link to="/"  class="links">
                           <span class="links-icon">
                               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-home "><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                           </span>
                           <span>Track alerts</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link to="create-alerts" class="links">
                          <span class="links-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu "><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
                          </span>
                          <span>Create alerts</span>
                        </router-link>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
</template>
<script>
export default {
    name: 'SideNavbar',
    data(){
        return{
            isLoading: false,
        }
    },
    methods:{
        toggleClass(){
            this.isLoading = !this.isLoading;
        }
    }
}
</script>
